import { Button, Flex, Link, Text } from "@jsq/ds/core";
import { formatShortFormDate } from "~/utils/datetime";
import {
  addDocumentButton,
  emptyCell,
  sourceDocumentContainer,
  sourceDocumentLink,
  sourceDocumentMeta,
} from "./styles_vanilla.css";
import { buildDocumentManagementUrl, type SourceDocumentInfo } from "./utils";

export type SourceDocumentCellProps = {
  caseId: number;
  sourceDocument: SourceDocumentInfo | null;
  onAddDocument?: () => void;
  readonly?: boolean;
};

export const SourceDocumentCell = ({
  caseId,
  sourceDocument,
  onAddDocument,
  readonly = false,
}: SourceDocumentCellProps) => {
  if (!sourceDocument) {
    if (readonly) {
      return (
        <Text variant="regular-md" className={emptyCell}>
          --
        </Text>
      );
    }
    return (
      <Button
        displayAsLink
        icon="plus"
        iconPosition="left"
        className={addDocumentButton}
        onClick={(event) => {
          event.stopPropagation();
          onAddDocument?.();
        }}
      >
        Add document
      </Button>
    );
  }
  return (
    <Flex
      className={sourceDocumentContainer}
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Flex flexDirection="column" gap={2}>
        <Text variant="regular-md">{sourceDocument.name}</Text>
        {sourceDocument.expiryDate && (
          <Text variant="secondary-sm" className={sourceDocumentMeta}>
            Expires on {formatShortFormDate(sourceDocument.expiryDate)}
          </Text>
        )}
      </Flex>
      <Link
        className={sourceDocumentLink}
        to={buildDocumentManagementUrl(caseId, sourceDocument.documentId)}
        icon="arrow-right"
        iconPosition="right"
      >
        View
      </Link>
    </Flex>
  );
};
